import { SortDirectionEnum, useInfiniteFindByQuery } from '../../graphql';
import { ISSUE_MESSAGE_FRAGMENT } from './issueMessageFragment';
import { ISSUE_MESSAGE_PAGE_COUNT } from './useFindIssueMessages';

/**
 * Side Chat (plan 0022 §B): messages belonging to a single side chat — i.e.
 * every message parented to `parentMessageId`. Mirrors `useFindIssueMessages`
 * but filters on `parentMessage` and orders oldest-first (updatedAt Asc) so the
 * panel reads top-to-bottom like a conversation.
 *
 * The `{ eq: parentMessageId }` filter is SAFE because `parentMessageId` is a
 * concrete non-null id. (The crash documented in bd memory
 * 0014-revisionof-eq-null only affects `{ eq: null }` on a relationship id — see
 * useFindIssueMessages.)
 */
export const useSideChatMessages = (parentMessageId: string) => {
  return useInfiniteFindByQuery({
    modelName: 'issueMessage',
    query: FIND_SIDE_CHAT_MESSAGES,
    orderBy: {
      field: 'updatedAt',
      order: SortDirectionEnum.Asc,
    },
    filter: {
      parentMessage: { eq: parentMessageId },
    },
    pageSize: ISSUE_MESSAGE_PAGE_COUNT,
  });
};

const FIND_SIDE_CHAT_MESSAGES = `
  query findIssueMessages($filter: IssueMessageFilter, $page: PageRequest, $orderBy: OrderByInput) {
    findIssueMessages(filter: $filter, page: $page, orderBy: $orderBy) {
      items {
        ${ISSUE_MESSAGE_FRAGMENT}
        promptRoutine {
          id
          name
          currentVersion {
            id
          }
          type
          config
        }
      }
      count
      offset
      limit
    }
  }
`;
